(() => {
  const selector = '.quick-buy-modal .quick-buy-wishlist-row';
  const setAttribute = (element, name, value) => {
    if (element.getAttribute(name) !== String(value)) element.setAttribute(name, value);
  };
  const syncRow = (row) => {
    const button = row.querySelector('.quick-buy-wishlist-button');
    if (!button) return;
    const wishlistOnly = row.dataset.purchaseHidden === 'true' || row.dataset.variantAvailable !== 'true';
    setAttribute(row, 'data-wishlist-only', wishlistOnly);
    let saved = [];
    try { saved = JSON.parse(localStorage.getItem('custom_wishlist') || '[]'); } catch (_) {}
    const active = Array.isArray(saved) && saved.includes(button.dataset.productHandle);
    if (button.classList.contains('active') !== active) button.classList.toggle('active', active);
    setAttribute(button, 'aria-pressed', active);
    setAttribute(button, 'aria-label', active ? 'Remove from wishlist' : 'Add to wishlist');
    const label = button.querySelector('.wishlist-label');
    const text = active ? 'REMOVE FROM WISHLIST' : 'ADD TO WISHLIST';
    if (label.textContent !== text) label.textContent = text;
    if (label.hidden !== !wishlistOnly) label.hidden = !wishlistOnly;
  };
  const sync = () => document.querySelectorAll(selector).forEach(syncRow);
  let queued = false;
  const schedule = () => {
    if (queued) return;
    queued = true;
    queueMicrotask(() => { queued = false; sync(); });
  };
  new MutationObserver(schedule).observe(document.body, {
    childList: true, subtree: true, attributes: true, attributeFilter: ['disabled', 'class']
  });
  document.addEventListener('click', (event) => {
    if (event.target.closest('.wishlist-action-btn, .wishlist-btn, .btn-wishlist')) schedule();
  });
  window.addEventListener('storage', schedule);
  document.addEventListener('variant:change', (event) => {
    if (!(event.target instanceof Element)) return;
    const form = event.target.closest('form');
    const row = form?.querySelector(selector);
    if (!row || !event.detail || !('variant' in event.detail)) return;
    setAttribute(row, 'data-variant-available', event.detail.variant?.available === true);
    syncRow(row);
  }, true);
  sync();
})();
